import type { PlayerPack } from '@library/types/playerPacks/playerPacks';

export const playerPacks: Array<PlayerPack> = [
  {
    id: '123',
    title: 'Player Pack 1',
    canFade: true,
    createdAt: 'May 8, 2025',
    imageUrl: 'https://example.com/image1.jpg',
    placeByTime: '5:30 PM',
    excludedStates: ['3', '5'],
    updatedAt: '',
    picks: [
      {
        projectionId: '11',
        playerName: 'Player 1',
        projectionValue: '20.5',
        statType: 'Points',
        playerImageUrl:
          'https://static.prizepicks.com/images/players/NBA/Luguentz_Dort_NBA_player_e1jWAiWanPNpRtbYeXm01a9Q.webp',
        leagueId: '7',
        gameId: '',
        gameDisplay: '',
        gameTime: '2025-06-05T20:30:00.000-04:00',
        oddsType: '',
        wagerType: 'more'
      },
      {
        projectionId: '12',
        playerName: 'Player 3',
        projectionValue: '5.5',
        statType: 'Assists',
        playerImageUrl:
          'https://static.prizepicks.com/images/players/NBA/Jalen_Williams_NBA_player_Gy76x01bCh1JQzfiqKe7Luxi.webp',
        leagueId: '9',
        gameId: '',
        gameDisplay: '',
        gameTime: '2025-06-06T21:40:00.000-04:00',
        oddsType: '',
        wagerType: 'less'
      }
    ]
  },
  {
    id: '124',
    title: 'Player Pack 2',
    canFade: false,
    createdAt: 'May 9, 2025',
    imageUrl: 'httsp://example.com/image2.jpg',
    placeByTime: '3:00 PM',
    excludedStates: ['25'],
    updatedAt: '',
    picks: [
      {
        projectionId: '21',
        playerName: 'Player 2',
        projectionValue: '15.5',
        statType: 'Rebounds',
        playerImageUrl: '',
        leagueId: '8',
        gameId: '1',
        gameDisplay: '',
        gameTime: '',
        oddsType: ''
      }
    ]
  }
];
